import {AccidentsGroup} from "@/read-model/AccidentsGroup";
import {Location} from "@/read-model/Location";

export class Marker {
  group: AccidentsGroup
  location: Location
  id: string
  iconUrl: string

  constructor(group: AccidentsGroup, groupIndex = 0) {
    this.group = group
    this.location = group.accidents[0].location
    this.id = `marker${group.isMultiple() ? '-multiple' : ''}-${groupIndex}`
    this.iconUrl = group.isTragic() ? (group.hasDead() ? 'ikonka_wypadek_smiertelny.svg' : 'ikonka_wypadek.svg') : 'ikonka_cud.svg'
  }
}
